// funções com prefixo set -> setam o conteúdo do html
// funções com prefixo get -> obtem conteúdo da API

window.addEventListener("gift.hero:initalized", function () {
  const { GiftHeroAPI } = window;
  const cardId = GiftHeroAPI.data.id;
  const variants = GiftHeroAPI.getVariants();
  const activeCard = getActiveCard(variants, cardId);

  const cardImage = document.querySelector("img.card-image");

  setActualPrice(activeCard);
  setVariants(variants, activeCard);
  setSendInputs("send-now");

  if (cardImage) setCardImage(variants, cardId, cardImage);

  const dateInput = document.querySelector("#date-input");
  dateInput.value = new Date().toISOString().substring(0, 10);
  const dateObj = new Date(dateInput.value);
  GiftHeroAPI.setDeliveryDate(dateObj);

  const nameInput = document.querySelector("#name-input");
  const defaultName = nameInput.getAttribute("data-default-name");
  if (defaultName) GiftHeroAPI.setFrom(defaultName);
});

window.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      document.activeElement.click();
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.id == "CartDrawer-Overlay") {
      const cart = document.querySelector("cart-drawer");
      cart.close();
    }
  });
});

const getActiveCard = (variants, activeId) => {
  const activeCard = variants.find(({ id }) => id == activeId);
  return activeCard;
};

const getSendMethod = () => {
  const sendButtons = document.querySelectorAll(".send-buttons>span.option");
  let sendMethod = null;
  sendButtons.forEach((button) => {
    if (button.classList.contains("active")) sendMethod = button.id;
  });
  return sendMethod;
};

const setActualPrice = (activeCard) => {
  const priceContainers = document.querySelectorAll(".active-value");
  priceContainers.forEach((container) => {
    const price = activeCard.title.substring(0, activeCard.title.indexOf("."));
    container.innerHTML = price;
  });
};

const setVariants = (variants, activeCard) => {
  const variantsContainer = document.querySelector(".card-variants");
  variants.forEach((variant) => {
    variantsContainer.innerHTML += `<span tabindex="0" class='button variant-option ${
      variant.id == activeCard.id ? "active" : ""
    }' data-variant-id="${variant.id}">${variant.title}</span>`;
  });

  const variantsEl = variantsContainer.querySelectorAll(".variant-option");
  variantsEl.forEach((variant) => {
    variant.addEventListener("click", handleVariantChange);
  });
};

const setSendInputs = (sendType) => {
  const dateInput = document.querySelector(".delivery-date>input");
  dateInput.setAttribute("send-type", sendType);
  if (sendType == "send-now") {
    dateInput.setAttribute("readonly", "true");
    dateInput.value = new Date().toISOString().substring(0, 10);
  } else {
    dateInput.removeAttribute("readonly");
  }
};

const setCardImage = (variants, targetId, imgElement) => {
  const card = getActiveCard(variants, targetId);
  imgElement.setAttribute("src", card.featured_image.src);
  imgElement.setAttribute("alt", card.featured_image.alt);
};

const handleVariantChange = (e) => {
  const { GiftHeroAPI } = window;
  const variants = GiftHeroAPI.getVariants();

  const cardImage = document.querySelector(".card-image");

  const el = e.target;
  const selectedId = el.getAttribute("data-variant-id");
  const selectedCard = getActiveCard(variants, selectedId);

  GiftHeroAPI.setVariant(selectedId);
  setActualPrice(selectedCard);

  Array.from(el.parentNode.children).forEach((children) => {
    const isActive = children.getAttribute("data-variant-id") == selectedId;

    if (isActive) {
      children.classList.add("active");
    } else {
      children.classList.remove("active");
    }
  });

  if (cardImage) setCardImage(variants, selectedId, cardImage);
};

const handleMessageChange = (e) => {
  const { GiftHeroAPI } = window;
  const message = e.target.value;
  GiftHeroAPI.setMessage(message);
};

const handleNameChange = (e) => {
  const { GiftHeroAPI } = window;
  const name = e.target.value;
  GiftHeroAPI.setFrom(name);
};

const handleSendChange = (e) => {
  const el = e.target;
  setSendInputs(el.id);

  Array.from(el.parentNode.children).forEach((children) => {
    const isActive = children.classList.contains("active");
    const isTarget = children == el;

    if (isTarget && !isActive) {
      children.classList.add("active");
    }
    if (!isTarget && isActive) {
      children.classList.toggle("active");
    }
  });
};

const handleDateChange = (e) => {
  const { GiftHeroAPI } = window;
  const sendType = e.target.getAttribute("send-type");
  const dateString = e.target.value;
  const date = new Date(dateString);
  if (sendType == "schedule") {
    date.setHours(e.target.getAttribute("hours-schedule"), 0);
  }
  GiftHeroAPI.setDeliveryDate(date);
};

const handleEmailChange = (e) => {
  const { GiftHeroAPI } = window;
  const el = e.target.value;

  const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const isValidMail = el.match(regex);

  if (isValidMail) GiftHeroAPI.setEmail(el);
};

const updateCartNotification = () => {
  const cartNotification = document.querySelector("cart-notification");

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      // sections: cartNotification.getSectionsToRender().map((section) => section.id).join(),
      sections: ["cart-notification-product", "cart-icon-bubble"],
      note: "",
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      cartNotification.renderContents(response, false, 'add-to-cart');
      localStorage.setItem("cart_items", JSON.stringify(response));
    });
};

const addToCart = async (e) => {
  try {
    const { GiftHeroAPI } = window;

    const id = GiftHeroAPI.data.id;
    const variants = GiftHeroAPI.getVariants();
    const cardObject = getActiveCard(variants, id);

    const dateInput = document.querySelector("#date-input");
    const sendType = dateInput.getAttribute("send-type");
    const date = new Date(`${dateInput.value}T00:00`);
    if (sendType == "schedule") {
      date.setHours(dateInput.getAttribute("hours-schedule"), 0);
    }
    GiftHeroAPI.setDeliveryDate(date);

    const formIsValid = validateCardForm(e);
    const cardIsValid = GiftHeroAPI.validate();

    if (cardIsValid.valid && formIsValid) {
      const data = await GiftHeroAPI.addToCart(1);
      updateCartNotification(data);
      // cartOpen(data.data.items[0]);
      // cartNotificate(cardObject);
      // updateCartCounter();
    }
  } catch (error) {
    alert(
      "There was an error adding the gift card to the cart. Please try again.",
    );
  }
};

const validateCardForm = (e) => {
  e.preventDefault();
  const form = document.querySelector(".gift-card-form");
  const inputs = form.querySelectorAll("input, textarea");
  let isValidForm = true;

  inputs.forEach((input) => {
    if (!checkInputValidity(input)) isValidForm = false;
  });
  return isValidForm;
};

const checkInputValidity = (InputEl) => {
  const feedback = InputEl.parentNode.querySelector(".invalid-feedback");
  if (!InputEl.checkValidity()) {
    feedback.style.display = "block";
    return false;
  } else {
    feedback.style.display = "none";
    return true;
  }
};

const cartOpen = async (data) => {
  const cart = document.querySelector("cart-drawer");
  cart.classList.add("active");

  await fetch(location.href)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Erro ao carregar a seção");
      }
      return response.text();
    })
    .then((data) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");

      const cartDrawer = doc.querySelector("cart-drawer");

      if (cart.innerHTML.includes("Your cart is empty")) {
        cart.classList.remove("is-empty");
      }
      cart.innerHTML = cartDrawer.innerHTML;
    });

  cart.open();
};

const cartNotificate = (cardObject) => {
  const cardData = window.GiftHeroAPI.cardData;
  const cartNotification = document.querySelector("#cart-notification");
  const container = document.querySelector("#cart-notification-product");
  const html = `
    <img 
        class="cart-notification-product__image" 
        src="${cardObject.featured_image.src}" 
        alt="${cardObject.featured_image.alt}" 
        width="70" 
        height="70" 
        loading="lazy"
        >
    <div 
        class="cart-notification-product__info"
    >
        <h3 class="cart-notification-product__name h4" >${cardObject.name}</h3>
        <dl>
            <div class="cart-notification-product__option h4">
                <dt>Value: </dt>
                <dd>${cardObject.title}.00</dd>
            </div>
        </dl>
        <dl>
            <div class="cart-notification-product__option h4">
                <dt>Your Name: </dt>
                <dd>${cardData.name}</dd>
            </div>
        </dl>
        <dl>
            <div class="cart-notification-product__option h4">
                <dt>Message: </dt>
                <dd>${cardData.message}</dd>
            </div>
        </dl>
    </div>
`;
  container.innerHTML = html;

  cartNotification.classList.add("active", "animate");
  setTimeout(() => {
    cartNotification.classList.remove("active", "animate");
  }, 3000);
};

const updateCartCounter = (e = () => {
  const counter = document.querySelector(
    "#cart-icon-bubble .cart-count-bubble span",
  );

  if (!counter) {
    const counterHTML = `
      <div class="cart-count-bubble">
          <span aria-hidden="true">1</span>
          <span class="visually-hidden">1 item</span>
      </div>
      `;

    document.querySelector("#cart-icon-bubble").innerHTML += counterHTML;
    return;
  }

  counter.innerText = Number(counter.innerText) + 1;
});
